import { Reveal } from "../../lib/motion";
import { FOOTER_NAV } from "../../lib/siteData";
import { scrollToId } from "./SmoothScroll";

const BRIEF_URL = "/EverSoul-Investor-Brief.pdf";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative pt-24 pb-10 border-t border-es-border">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 pb-20">
          <div className="lg:col-span-5">
            <p className="font-serif text-es-fg text-2xl leading-snug">EverSoul.world</p>
            <p className="text-es-muted-fg text-sm mt-4 max-w-xs leading-relaxed">
              Consent governed digital legacy and personal identity infrastructure.
            </p>
            <p className="font-serif italic text-es-fg text-xl leading-snug max-w-sm mt-8">
              What continues should remain faithful to the person who began it.
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="text-[11px] uppercase tracking-[0.3em] text-es-muted-fg mb-5">Explore</p>
            <ul className="space-y-3">
              {FOOTER_NAV.map((n) => (
                <li key={n.id}>
                  <button
                    data-testid={`footer-nav-${n.id}`}
                    onClick={() => scrollToId(n.id)}
                    className="text-es-muted-fg hover:text-es-fg transition-colors duration-300 text-sm"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href={BRIEF_URL}
                  download
                  data-testid="footer-brief"
                  className="text-es-muted-fg hover:text-es-fg transition-colors duration-300 text-sm"
                >
                  Investor Brief
                </a>
              </li>
              <li>
                <a
                  href="/how-it-works"
                  data-testid="footer-how-it-works"
                  className="text-es-muted-fg hover:text-es-fg transition-colors duration-300 text-sm"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="/legacy-intelligence-index"
                  data-testid="footer-legacy-index"
                  className="text-es-muted-fg hover:text-es-fg transition-colors duration-300 text-sm"
                >
                  Legacy Intelligence Index
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-es-muted-fg mb-5">Contact</p>
            <a
              href="mailto:greg@eversoul.world?subject=EverSoul%20inquiry"
              data-testid="footer-email"
              className="text-es-fg hover:text-es-accent transition-colors duration-300 text-sm"
            >
              greg@eversoul.world
            </a>
            <p className="text-es-muted-fg text-sm mt-4">Provisional patent pending</p>
          </div>
        </div>

        <Reveal>
          <div className="border-t border-es-border pt-10">
            <h2 className="font-serif font-light text-es-fg tracking-tighter leading-none text-[clamp(3rem,17vw,17rem)]">
              EVERSOUL
            </h2>
          </div>
        </Reveal>

        <div className="flex flex-col sm:flex-row justify-between gap-3 mt-8 text-[12px] text-es-muted-fg">
          <span>© {new Date().getFullYear()} EverSoul.world — All rights reserved.</span>
          <span>Values transmission, not legal automation. Humans retain authority.</span>
        </div>
      </div>
    </footer>
  );
};
